/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PropertyBreakdownItem,
    PropertyBreakdownItemFromJSON,
    PropertyBreakdownItemFromJSONTyped,
    PropertyBreakdownItemToJSON,
} from './PropertyBreakdownItem';

/**
 * 
 * @export
 * @interface IntervalPropertyBreakdown
 */
export interface IntervalPropertyBreakdown {
    /**
     * 
     * @type {string}
     * @memberof IntervalPropertyBreakdown
     */
    startingFrom: string;
    /**
     * 
     * @type {string}
     * @memberof IntervalPropertyBreakdown
     */
    endingAt: string;
    /**
     * 
     * @type {Array<PropertyBreakdownItem>}
     * @memberof IntervalPropertyBreakdown
     */
    items: Array<PropertyBreakdownItem>;
}

export function IntervalPropertyBreakdownFromJSON(json: any): IntervalPropertyBreakdown {
    return IntervalPropertyBreakdownFromJSONTyped(json, false);
}

export function IntervalPropertyBreakdownFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntervalPropertyBreakdown {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'startingFrom': json['starting_from'],
        'endingAt': json['ending_at'],
        'items': ((json['items'] as Array<any>).map(PropertyBreakdownItemFromJSON)),
    };
}

export function IntervalPropertyBreakdownToJSON(value?: IntervalPropertyBreakdown | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'starting_from': value.startingFrom,
        'ending_at': value.endingAt,
        'items': ((value.items as Array<any>).map(PropertyBreakdownItemToJSON)),
    };
}

